import Service from "./Service";

class TicketApiService extends Service {
  constructor() {
    super("api/Tickets");
  }

  async getAll() {
    let result = await this.get(``, (status, data) => {
      return data;
    });
    return result;
  }

  async getTicketsForPublic() {
    let result = await this.get(`GetTicketsForPublic`, (status, data) => {
      return data;
    });
    return result;
  }

  async deleteById(id) {
    let result = await this.delete(`/${id}`, (status, data) => {
      return data;
    });
    return result;
  }

  async getById(ticketId) {
    let result = await this.get(`GetTicketById?ticketId=${ticketId}`, (status, data) => {
      return data;
    });
    return result;
  }

  async update(id, payload) {
    let result = await this.post(`/${id}`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async add(payload) {
    let result = await this.post(``, payload, (status, data) => {
      return data;
    });
    return result;
  }
}

export default new TicketApiService();
